import { render, staticRenderFns } from "./EndorsementsTable.vue?vue&type=template&id=520ef95c"
import script from "./EndorsementsTable.vue?vue&type=script&lang=ts"
export * from "./EndorsementsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports